<template>
    <HomeLayout>
        <section class="page-hero">
            <div class="page-hero-content">
                <div class="page-eyebrow"><span></span> Legal</div>
                <h1>Terms of <em>Use</em></h1>
                <p>Please read these terms carefully before using the Succour platform. By using our services, you agree
                    to be bound by these terms.</p>
            </div>
        </section>
        <div class="legal-layout">
            <aside class="legal-sidebar">
                <h3>Contents</h3>
                <a class="legal-nav-link" href="#">1. About Our Services</a><a class="legal-nav-link" href="#">2. User
                    Eligibility</a><a class="legal-nav-link" href="#">3. Caregiver Verification</a><a
                    class="legal-nav-link" href="#">4. User Responsibilities</a><a class="legal-nav-link" href="#">5.
                    Payments & Fees</a><a class="legal-nav-link" href="#">6. Limitation of Liability</a><a
                    class="legal-nav-link" href="#">7. Changes to These Terms</a><a class="legal-nav-link" href="#">8.
                    Contact</a>
            </aside>
            <main>
                <p class="legal-meta">Last Updated: August 25, 2024</p>
                <div class="legal-section" id="1.-about-o">
                    <h2>1. About Our Services</h2>
                    <p>Succour's mission is to provide an online venue for families and caregivers to connect, arrange
                        care, and share information. We work to fulfil this mission by making available online
                        communication tools, information, and an extended network of care seekers and care givers.</p>
                    <p>We enable individuals seeking care services including child care, elderly care, and housekeeping
                        to review and connect with professionals who provide these services. We provide search tools,
                        profile pages, and a messaging platform without being a party to any arrangements you make.</p>
                </div>
                <div class="legal-section" id="2.-user-el">
                    <h2>2. User Eligibility</h2>
                    <p>The Succour platform is available to individuals residing in Nigeria who are 18 years of age or
                        older. By using the platform, you represent and warrant that you meet this requirement. Succour
                        reserves the right to verify eligibility at any time.</p>
                </div>
                <div class="legal-section" id="3.-caregiv">
                    <h2>3. Caregiver Verification</h2>
                    <p>While Succour conducts comprehensive screening including medical checks, criminal background
                        verification, and guarantor vetting care seekers are ultimately responsible for independently
                        verifying any information provided by caregivers. Succour strongly advises care seekers to only
                        work with caregivers who carry a verified badge on the platform.</p>
                </div>
                <div class="legal-section" id="4.-user-re">
                    <h2>4. User Responsibilities</h2>
                    <ul>
                        <li>Provide accurate and complete information when creating an account or posting requirements.
                        </li>
                        <li>Maintain the confidentiality of your account credentials.</li>
                        <li>Use the platform only for lawful purposes and in accordance with these Terms.</li>
                        <li>Treat all parties caregivers, families, and Succour staff with respect and dignity.</li>
                        <li>Report any concerns about caregiver conduct or safety through our official channels.</li>
                    </ul>
                </div>
                <div class="legal-section" id="5.-payment">
                    <h2>5. Payments & Fees</h2>
                    <p>Succour provides transparent pricing for all services. All fees are communicated clearly before
                        any commitment is made. Payment terms and billing schedules are outlined during the onboarding
                        process. Succour does not charge hidden fees.</p>
                </div>
                <div class="legal-section" id="6.-limitat">
                    <h2>6. Limitation of Liability</h2>
                    <p>Succour acts as an intermediary platform and is not responsible for the actions, omissions, or
                        conduct of any caregiver or care seeker. To the maximum extent permitted by applicable law,
                        Succour shall not be liable for any indirect, incidental, or consequential damages arising from
                        your use of the platform.</p>
                </div>
                <div class="legal-section" id="7.-changes">
                    <h2>7. Changes to These Terms</h2>
                    <p>Succour reserves the right to modify these Terms at any time. We will notify registered users of
                        significant changes via email or a prominent notice on the platform no less than 30 days before
                        changes take effect. Continued use of the platform constitutes acceptance of the revised Terms.
                    </p>
                </div>
                <div class="legal-section" id="8.-contact">
                    <h2>8. Contact</h2>
                    <p>For questions about these Terms of Use, please contact us at <a
                            href="/cdn-cgi/l/email-protection" class="__cf_email__"
                            data-cfemail="97fff2fbfbf8d7e4e2f4f4f8e2e5b9f4f6e5f2">[email&#160;protected]</a> or call
                        +234 918 000 2370.</p>
                </div>
            </main>
        </div>
    </HomeLayout>
</template>

<script lang="js">
import HomeLayout from '../Layouts/HomeLayout.vue';

export default {
    name: "TermsOfUse",
    components: {
        HomeLayout,
    }
}
</script>

<style lang="css" scoped>
:root {
    --pink: #F59CAB;
    --pink-light: #FDE8EC;
    --pink-mid: #F8C4CC;
    --green: #17865F;
    --green-dark: #0f5c41;
    --green-light: #E8F5EF;
    --cream: #FDF9F7;
    --orange: #FF9700;
    --text-dark: #1C2B27;
    --text-mid: #4A5E58;
    --text-light: #8A9E98;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
}

body {
    font-family: 'Open Sans', sans-serif;
    background: var(--cream);
    color: var(--text-dark);
    overflow-x: hidden;
}

.ribbon {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1100;
    background: var(--green);
    color: white;
    padding: 9px 20px;
    font-size: .84rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-shadow: 0 2px 12px rgba(23, 134, 95, .2);
}

.ribbon span {
    opacity: .88;
    font-weight: 300;
}

.ribbon a {
    background: white;
    color: var(--green);
    padding: 5px 16px;
    border-radius: 100px;
    font-weight: 700;
    font-size: .8rem;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: background .2s, color .2s;
}

.ribbon a:hover {
    background: var(--pink);
    color: white;
}

nav {
    position: fixed;
    top: 38px;
    left: 0;
    right: 0;
    z-index: 900;
    background: rgba(253, 249, 247, .96);
    backdrop-filter: blur(14px);
    border-bottom: 1px solid rgba(245, 156, 171, .12);
    padding: 0 6%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.nav-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
}

.logo-text {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.35rem;
    font-weight: 700;
    color: var(--text-dark);
}

.logo-text sup {
    font-size: .5rem;
    color: var(--text-light);
    font-weight: 400;
}

.nav-links {
    display: flex;
    align-items: center;
    gap: 26px;
    list-style: none;
}

.nav-links a {
    font-size: .85rem;
    color: var(--text-mid);
    text-decoration: none;
    font-weight: 400;
    transition: color .2s;
    padding-bottom: 2px;
    border-bottom: 2px solid transparent;
}

.nav-links a:hover,
.nav-links a.active {
    color: var(--green);
    border-bottom-color: var(--green);
}

.nav-ctas {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-ghost {
    font-family: 'Open Sans', sans-serif;
    font-size: .85rem;
    color: var(--text-mid);
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px 14px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 400;
    transition: color .2s;
}

.btn-ghost:hover {
    color: var(--green);
}

.btn-primary {
    font-family: 'Open Sans', sans-serif;
    font-size: .85rem;
    font-weight: 700;
    background: var(--pink);
    color: white;
    border: none;
    padding: 10px 22px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    transition: background .2s, transform .15s;
}

.btn-primary:hover {
    background: #e8849a;
    transform: translateY(-1px);
}

.btn-green {
    font-family: 'Open Sans', sans-serif;
    font-size: .9rem;
    font-weight: 700;
    background: var(--green);
    color: white;
    border: none;
    padding: 13px 32px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition: background .2s, transform .15s;
}

.btn-green:hover {
    background: var(--green-dark);
    transform: translateY(-1px);
}

.btn-outline-green {
    font-family: 'Open Sans', sans-serif;
    font-size: .9rem;
    font-weight: 700;
    background: transparent;
    color: var(--green);
    border: 2px solid var(--green);
    padding: 11px 28px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition: background .2s, color .2s;
}

.btn-outline-green:hover {
    background: var(--green);
    color: white;
}

.page-hero {
    padding: 160px 7% 80px;
    background: var(--cream);
    position: relative;
    overflow: hidden;
}

.page-hero::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 45%;
    height: 100%;
    background: var(--pink-light);
    border-radius: 60px 0 0 60px;
    opacity: .45;
    z-index: 0;
}

.page-hero-content {
    position: relative;
    z-index: 1;
    max-width: 600px;
}

.page-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: var(--green-light);
    color: var(--green);
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    padding: 6px 14px;
    border-radius: 100px;
    margin-bottom: 20px;
}

.page-eyebrow span {
    width: 6px;
    height: 6px;
    background: var(--green);
    border-radius: 50%;
}

.page-hero h1 {
    font-family: 'Lora', serif;
    font-size: clamp(2.2rem, 4vw, 3.4rem);
    font-weight: 400;
    line-height: 1.12;
    color: var(--text-dark);
    margin-bottom: 18px;
}

.page-hero h1 em {
    font-style: italic;
    color: var(--green);
}

.page-hero p {
    font-size: 1rem;
    color: var(--text-mid);
    line-height: 1.75;
    font-weight: 300;
    max-width: 500px;
}

.section-label {
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .12em;
    text-transform: uppercase;
    color: var(--pink);
    margin-bottom: 10px;
}

.section-title {
    font-family: 'Lora', serif;
    font-size: clamp(1.6rem, 2.6vw, 2.3rem);
    font-weight: 400;
    color: var(--text-dark);
    line-height: 1.2;
    margin-bottom: 12px;
}

.section-title em {
    font-style: italic;
    color: var(--green);
}

.section-sub {
    font-size: .95rem;
    color: var(--text-mid);
    max-width: 520px;
    line-height: 1.7;
    font-weight: 300;
    margin-bottom: 44px;
}

footer {
    background: var(--text-dark);
    padding: 68px 7% 30px;
}

.footer-grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 48px;
    margin-bottom: 56px;
}

.footer-logo-text {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.3rem;
    font-weight: 700;
    color: white;
}

.footer-logo-text sup {
    font-size: .48rem;
    color: rgba(255, 255, 255, .3);
    font-weight: 400;
}

.footer-tagline {
    font-size: .83rem;
    color: rgba(255, 255, 255, .42);
    line-height: 1.7;
    margin: 14px 0 22px;
    font-weight: 300;
    max-width: 230px;
}

.footer-socials {
    display: flex;
    gap: 8px;
}

.social-btn {
    width: 34px;
    height: 34px;
    background: rgba(255, 255, 255, .07);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, .45);
    font-size: .78rem;
    text-decoration: none;
    font-weight: 700;
    transition: background .2s, color .2s;
}

.social-btn:hover {
    background: var(--pink);
    color: white;
}

.footer-col h4 {
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, .35);
    margin-bottom: 18px;
}

.footer-col ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.footer-col a {
    font-size: .85rem;
    color: rgba(255, 255, 255, .55);
    text-decoration: none;
    font-weight: 300;
    transition: color .2s;
}

.footer-col a:hover {
    color: var(--pink);
}

.footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, .07);
    padding-top: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.footer-bottom p {
    font-size: .76rem;
    color: rgba(255, 255, 255, .25);
    font-weight: 300;
}

@media(max-width:768px) {
    .nav-links {
        display: none;
    }

    .footer-grid {
        grid-template-columns: 1fr;
    }

    .page-hero {
        padding: 140px 5% 60px;
    }
}

.legal-layout {
    padding: 80px 7% 100px;
    background: white;
    display: grid;
    grid-template-columns: 220px 1fr;
    gap: 64px;
    align-items: start;
}

.legal-sidebar {
    position: sticky;
    top: 120px;
}

.legal-sidebar h3 {
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: var(--text-light);
    margin-bottom: 14px;
}

.legal-nav-link {
    display: block;
    font-size: .85rem;
    color: var(--text-mid);
    text-decoration: none;
    padding: 8px 12px;
    border-radius: 8px;
    margin-bottom: 2px;
    font-weight: 300;
    transition: background .2s, color .2s;
}

.legal-nav-link:hover {
    background: var(--green-light);
    color: var(--green);
}

.legal-meta {
    font-size: .78rem;
    color: var(--text-light);
    margin-bottom: 32px;
    font-weight: 300;
}

.legal-section {
    margin-bottom: 44px;
}

.legal-section h2 {
    font-family: 'Lora', serif;
    font-size: 1.25rem;
    font-weight: 400;
    color: var(--text-dark);
    margin-bottom: 14px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--pink-light);
}

.legal-section p,
.legal-section li {
    font-size: .88rem;
    color: var(--text-mid);
    line-height: 1.85;
    font-weight: 300;
    margin-bottom: 12px;
}

.legal-section ul {
    padding-left: 20px;
}

.legal-section li {
    margin-bottom: 6px;
}

@media(max-width:900px) {
    .legal-layout {
        grid-template-columns: 1fr;
    }

    .legal-sidebar {
        position: static;
    }
}

/* ── UNIVERSAL MOBILE SAFETY ── */
@media(max-width:480px) {

    .hero h1,
    .page-title {
        font-size: 2rem !important;
    }

    .section-title {
        font-size: 1.5rem !important;
    }

    nav {
        padding: 0 4%;
    }

    .nav-ctas .btn-ghost:first-child {
        display: none;
    }

    .ribbon {
        font-size: .78rem;
        padding: 8px 12px;
        gap: 6px;
    }

    .ribbon a {
        padding: 4px 10px;
        font-size: .75rem;
    }

    .hero-ctas {
        flex-direction: column;
    }

    .hero-ctas a {
        text-align: center;
    }

    .service-grid {
        grid-template-columns: 1fr !important;
    }

    .cg-grid {
        grid-template-columns: 1fr !important;
    }

    .steps {
        grid-template-columns: 1fr !important;
    }

    .steps::before {
        display: none !important;
    }

    .audience-grid {
        grid-template-columns: 1fr !important;
    }

    .testi-grid {
        grid-template-columns: 1fr !important;
    }

    .footer-grid {
        grid-template-columns: 1fr !important;
    }

    .about-story,
    .why,
    .pitch-grid,
    .contact-invest {
        grid-template-columns: 1fr !important;
    }

    .metrics {
        grid-template-columns: 1fr 1fr !important;
    }

    .opp-grid,
    .values-grid {
        grid-template-columns: 1fr !important;
    }

    .faq-layout,
    .legal-layout {
        grid-template-columns: 1fr !important;
        padding: 32px 5% 48px !important;
    }

    .faq-sidebar,
    .legal-sidebar {
        position: static !important;
    }

    .apply-cta {
        grid-template-columns: 1fr !important;
        padding: 32px 24px !important;
    }

    .values-grid {
        grid-template-columns: 1fr !important;
    }

    .page-banner {
        padding: 80px 5% 40px !important;
    }

    .services,
    .why,
    .how,
    .caregivers,
    .audience,
    .testimonials,
    .about-story,
    .values,
    .mission-strip,
    .traction,
    .opportunity {
        padding: 52px 5% !important;
    }

    .cg-grid {
        grid-template-columns: 1fr 1fr !important;
    }

    .hero-badge {
        display: none;
    }

    .invest-form {
        padding: 28px 20px !important;
    }
}

@media(max-width:1024px) {
    .faq-layout {
        grid-template-columns: 200px 1fr;
        gap: 32px;
    }

    .legal-layout {
        grid-template-columns: 190px 1fr;
        gap: 32px;
    }

    .metrics {
        grid-template-columns: repeat(2, 1fr);
    }

    .opp-grid {
        grid-template-columns: 1fr 1fr;
    }
}


/* WHATSAPP BUBBLE */
.wa-bubble {
    position: fixed;
    bottom: 28px;
    right: 28px;
    z-index: 2000;
    display: flex;
    align-items: center;
    gap: 0;
    cursor: pointer;
}

.wa-bubble-label {
    background: white;
    color: #1C2B27;
    font-family: 'Open Sans', sans-serif;
    font-size: .82rem;
    font-weight: 600;
    padding: 10px 16px;
    border-radius: 100px 0 0 100px;
    box-shadow: -4px 2px 14px rgba(0, 0, 0, .1);
    white-space: nowrap;
    max-width: 0;
    overflow: hidden;
    opacity: 0;
    transition: max-width .4s ease, opacity .3s ease, padding .3s ease;
    padding-left: 0;
    padding-right: 0;
}

.wa-bubble:hover .wa-bubble-label {
    max-width: 180px;
    opacity: 1;
    padding: 10px 16px;
}

.wa-btn {
    width: 56px;
    height: 56px;
    background: #25D366;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 20px rgba(37, 211, 102, .4);
    animation: waPulse 2.5s ease-in-out infinite;
    flex-shrink: 0;
    text-decoration: none;
}

.wa-btn svg {
    width: 28px;
    height: 28px;
    fill: white;
}

@keyframes waPulse {

    0%,
    100% {
        box-shadow: 0 4px 20px rgba(37, 211, 102, .4);
    }

    50% {
        box-shadow: 0 4px 32px rgba(37, 211, 102, .7), 0 0 0 8px rgba(37, 211, 102, .12);
    }
}

@media(max-width:480px) {
    .wa-bubble {
        bottom: 18px;
        right: 18px;
    }

    .wa-btn {
        width: 48px;
        height: 48px;
    }
}


.footer-socials {
    display: flex;
    gap: 10px;
}

.social-btn {
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, .07);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transition: background .2s;
}

.social-btn:hover {
    background: var(--pink);
}

.social-btn svg {
    width: 16px;
    height: 16px;
    fill: rgba(255, 255, 255, .55);
    transition: fill .2s;
}

.social-btn:hover svg {
    fill: white;
}
</style>